import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import './App.css';
import { ApplicationEditor } from './pages/ApplicationEditor';
import { Main } from './pages/Main/Main';
import { FocusStyleManager } from '@blueprintjs/core';
import { Search } from './pages/Search';
import { CreateApplication } from './pages/CreateApplication/CreateApplication';

FocusStyleManager.onlyShowFocusOnTabs();

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Main />}>
      <Route index element={<Navigate to="/search" replace />} />
      {/* Makes sure legacy routes are redirected to /search */}
      <Route path="/search/*" element={<Navigate to="/search" replace />} />
      <Route path="/search" element={<Search />} />
      <Route path="/create" element={<CreateApplication />} />

      <Route path="/application">
        <Route path=":applicationID" element={<ApplicationEditor />} />
      </Route>
    </Route>,
  ),
);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
